import { CONTRACT_COLUMN_NAME } from '../../../EntityTab'

export const MOCK_CONTRACTS_PAGE_SIZE = 20

export const CONTRACT_VIEWER_ROLE = {
  Dweller: 'dweller',
  Staff: 'staff',
}

export const CONTRACT_REQUIRED_COLUMNS = [
  CONTRACT_COLUMN_NAME.Flat,
  CONTRACT_COLUMN_NAME.Building,
]

export const CONTRACT_COLUMN_CONFIG = {
  [CONTRACT_COLUMN_NAME.Area]: {
    index: 11,
    title: 'ContractTable.TotalSpaceColumnKey',
    width: 150,
  },
  [CONTRACT_COLUMN_NAME.Building]: {
    index: 7,
    title: 'ContractTable.BuildingColumnKey',
    width: 200,
  },
  [CONTRACT_COLUMN_NAME.Category]: {
    index: 10,
    title: 'ContractTable.CategoryColumnKey',
    width: 160,
  },
  [CONTRACT_COLUMN_NAME.ContractEnd]: {
    index: 3,
    title: 'ContractTable.EndDateColumnKey',
    width: 150,
  },
  [CONTRACT_COLUMN_NAME.ContractId]: {
    index: 0,
    title: 'ContractTable.ContractIdColumnKey',
    width: 160,
  },
  [CONTRACT_COLUMN_NAME.ContractStart]: {
    index: 2,
    title: 'ContractTable.StartDateColumnKey',
    width: 150,
  },
  [CONTRACT_COLUMN_NAME.DelayedDate]: {
    index: 4,
    title: 'ContractTable.DelayedDateColumnKey',
    width: 160,
  },
  [CONTRACT_COLUMN_NAME.Duration]: {
    index: 5,
    title: 'ContractTable.DurationColumnKey',
    width: 140,
  },
  [CONTRACT_COLUMN_NAME.Dwellers]: {
    index: 9,
    title: 'ContractTable.TenantsColumnKey',
    width: 200,
  },
  [CONTRACT_COLUMN_NAME.EntranceAddress]: {
    index: 14,
    title: 'ContractTable.EntranceAddressColumnKey',
    width: 180,
  },
  [CONTRACT_COLUMN_NAME.Flat]: {
    index: 6,
    title: 'ContractTable.FlatColumnKey',
    width: 130,
  },
  [CONTRACT_COLUMN_NAME.Floor]: {
    index: 15,
    title: 'ContractTable.FloorColumnKey',
    width: 120,
  },
  [CONTRACT_COLUMN_NAME.HeatType]: {
    index: 12,
    title: 'ContractTable.HeatTypeColumnKey',
    width: 160,
  },
  [CONTRACT_COLUMN_NAME.Landlords]: {
    index: 8,
    title: 'ContractTable.LandlordsColumnKey',
    width: 200,
  },
  [CONTRACT_COLUMN_NAME.LiveArea]: {
    index: 17,
    title: 'ContractTable.LivingSpaceColumnKey',
    width: 150,
  },
  [CONTRACT_COLUMN_NAME.PropertyShare]: {
    index: 13,
    title: 'ContractTable.PropertyShareColumnKey',
    width: 160,
  },
  [CONTRACT_COLUMN_NAME.RoomCount]: {
    index: 16,
    title: 'ContractTable.RoomColumnKey',
    width: 120,
  },
  [CONTRACT_COLUMN_NAME.SecondContractId]: {
    index: 1,
    title: 'ContractTable.SecondContractIdColumnKey',
    width: 180,
  },
}

export const CONTRACT_DWELLER_VISIBLE_COLUMNS = [
  CONTRACT_COLUMN_NAME.Flat,
  CONTRACT_COLUMN_NAME.Building,
  CONTRACT_COLUMN_NAME.Landlords,
  CONTRACT_COLUMN_NAME.Dwellers,
  CONTRACT_COLUMN_NAME.Area,
  CONTRACT_COLUMN_NAME.Floor,
  CONTRACT_COLUMN_NAME.RoomCount,
  CONTRACT_COLUMN_NAME.LiveArea,
]
